import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {PanelOblogaDropdownModel} from '../models/ProizvodnjaModel'
import {PanelObloge} from '../models/PanelSifarniciModel'

const API_URL = process.env.REACT_APP_API_URL
const DROPDOWN_API = `${API_URL}/paneli/getOblogePanela`
const API = `${API_URL}/paneli/panelObloge`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

// Get request for dropdown data.
export async function getOblogePanela() {
  try {
    return await axios.get<Array<PanelOblogaDropdownModel>>(DROPDOWN_API, {
      headers: headers,
    })
  } catch (error) {
    console.error('Error fetching Dropdown data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}
export async function getAllOblogePanela(pageNo: number, perPage: number) {
  const params = {per_page: perPage, page: pageNo}
  return await axios.get<Array<PanelObloge>>(API, {headers: headers, params: params})
}

export async function fetchOblogaPanela(Id: number): Promise<Partial<PanelObloge>> {
  try {
    const response = await axios.get(`${API}/${Id}`)
    return response.data.data
  } catch (error: any) {
    console.error('Error fetching data:', error)
    return error.response.data
  }
}

export async function saveOblogaPanela(Data: any) {
  try {
    const response = await axios.post(API, Data, {headers: headers})
    if (response.data.error === 0) {
      return response.data
    } else {
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error
  }
}

export async function updateOblogaPanela(Data: any, id: number) {
  try {
    const response = await axios.post(`${API}/${id}?_method=PATCH`, Data, {headers: headers})
    return response.data
  } catch (error: any) {
    console.error('Error fetching data:', error)
    return error.response.data
  }
}

export async function deleteOblogaPanela(Id: number) {
  try {
    const response = await axios.delete(`${API}/${Id}`, {headers: headers})
    return response.data
  } catch (error: any) {
    console.error('Error deleting data:', error)
    return error.response.data
  }
}
